<template>
    <v-card-text class="px-0">
        <div class="my-4 mb-16 d-flex px-6">
            <v-btn color="black" icon @click="goBack">
                <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-spacer />
            <v-avatar left color="primary lighten-3">
                <v-img
                    alt="User avatar image"
                    :src="avatarLink"
                    v-if="avatarLink && userSettings.show_avatar"
                ></v-img>
                <v-icon v-else>mdi-account-outline</v-icon>
            </v-avatar>
        </div>

        <p
            v-if="selectedStat"
            class="title primary--text my-0 font-weight-bold mx-6"
        >
            {{ selectedStat.title }}
        </p>

        <div class="px-6" v-if="!selectedStat">
            <template v-for="stat in invoiceStats">
                <v-sheet
                    :key="stat.color"
                    :color="stat.color"
                    class="d-flex px-4 py-6 rounded-xl mt-8"
                >
                    <p class="black--text mb-0 mt-2 text-capitalize title">
                        {{ stat.title }}
                    </p>
                    <v-spacer />
                    <div class="d-flex text-right">
                        <p class="text-h3 black--text my-0 font-weight-bold">
                            {{ stat.number }}
                        </p>
                        <v-btn
                            color="black"
                            x-large
                            icon
                            @click="selectedStat = stat"
                        >
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                    </div>
                </v-sheet>
            </template>
        </div>

        <div id="scroller" class="px-4 mx-2" v-else>
            <template v-for="recipient in recipients">
                <v-sheet
                    :key="recipient.email"
                    tile
                    class="d-flex pa-4 rounded-xl mt-5 lighten-3"
                    :color="getBackgroundColor(selectedStat)"
                >
                    <v-row>
                        <v-col cols="8">
                             <p class="black--text subtitle-1 font-weight-bold my-0">
                                {{ recipient.name }}
                            </p>
                            <p class="black--text subtitle-2 my-0">
                                {{ recipient.email }}
                            </p>
                            <p class="black--text subtitle-2 my-0">
                                {{ recipient.country }}
                            </p>
                        </v-col>
                        <v-col class="text-right col-md-4 col-12">
                            <v-sheet
                                class="rounded-xl black--text mt-4 px-4 py-2 text-center text-none font-weight-bold"
                                :color="selectedStat.color"
                            >
                                $2,450.31
                            </v-sheet>
                        </v-col>
                    </v-row>
                </v-sheet>
            </template>
        </div>
    </v-card-text>
</template>

<script>
import recipients from '../modules/recipients.json';

export default {
    data() {
        return {
            selectedStat: null,
            recipients,
        }
    },
    props: {
        invoiceStats: Array,
    },
    computed: {
        avatarLink() {
            return this.$store.state.user.avatar;
        },
        userSettings() {
            if (_.isEmpty(this.$store.state.userSettings)) {
                return {
                    show_name: true,
                    show_avatar: true,
                };
            }

            return this.$store.state.userSettings;
        }
    },
    methods: {
        goBack() {
            if(!!this.selectedStat) {
                this.selectedStat = null;
                return;
            }

            this.$emit('close');
        },
        getBackgroundColor({ title }) {
            return title === 'Unpaid'
                ? 'rgba(243, 63, 63, 0.16)'
                : title === 'Paid'
                ? 'rgba(73, 226, 181, 0.19)'
                : 'rgba(245, 143, 99, 0.19)';
        },
    },
}
</script>

<style scoped>
#scroller {
    max-height: 55vh;
    height: 49vh;
    overflow-y: auto;
}
</style>